import { Box, Button, Card, CardContent, Skeleton, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
        height: '100%',
        display: 'flex',
        textAlign: 'left',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
}));

// ----------------------------------------------------------------------

const LessonCardSkeleton: React.FunctionComponent = () => {
    return (
        <RootStyle>
            <CardContent
                sx={{
                    p: { md: 3 },
                    pl: { md: 5 },
                    color: 'grey.800',
                    width: '100%',
                }}
            >
                <Box sx={{ flexGrow: 1 }}>
                    <Typography variant='subtitle2'>
                        <Skeleton sx={{ width: '20%', mx: { xs: 'auto', md: 'inherit' } }} />
                    </Typography>
                    <Typography gutterBottom variant='h5'>
                        <Skeleton sx={{ width: '60%', mx: { xs: 'auto', md: 'inherit' } }} />
                    </Typography>

                    <Skeleton sx={{ mx: { xs: 'auto', md: 'inherit' } }}>
                        <Button variant='contained'>Continue</Button>
                    </Skeleton>
                </Box>
            </CardContent>
        </RootStyle>
    );
};

export default LessonCardSkeleton;
